var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgConcatenate = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#31C4C0",
    d: "M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBFAF9",
    d: "M14.028 13.467a.15.15 0 0 1 0 .212l-.424.424a.15.15 0 0 1-.212 0l-.76-.76a.15.15 0 0 1 0-.212l.424-.425a.15.15 0 0 1 .212 0l.76.76Zm-1.458-1.459a.15.15 0 0 1 0 .212l-.425.425a.15.15 0 0 1-.212 0l-.76-.76a.15.15 0 0 1 0-.213l.424-.424a.15.15 0 0 1 .213 0zm-1.459-1.458a.15.15 0 0 1 0 .212l-.424.424a.15.15 0 0 1-.212 0l-.76-.76a.15.15 0 0 1 0-.212l.424-.424a.15.15 0 0 1 .212 0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBFAF9",
    fillRule: "evenodd",
    d: "M9.375 7.875v.9a.6.6 0 0 1-.6.6h-.9a1.5 1.5 0 0 0-1.5 1.5v5.25a1.5 1.5 0 0 0 1.5 1.5h5.25a1.5 1.5 0 0 0 1.5-1.5v-.9a.6.6 0 0 1 .6-.6h.9a1.5 1.5 0 0 0 1.5-1.5v-5.25a1.5 1.5 0 0 0-1.5-1.5h-5.25a1.5 1.5 0 0 0-1.5 1.5m6.75-.6h-5.25a.6.6 0 0 0-.6.6v.9a1.5 1.5 0 0 1-1.5 1.5h-.9a.6.6 0 0 0-.6.6v5.25a.6.6 0 0 0 .6.6h5.25a.6.6 0 0 0 .6-.6v-.9a1.5 1.5 0 0 1 1.5-1.5h.9a.6.6 0 0 0 .6-.6v-5.25a.6.6 0 0 0-.6-.6",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgConcatenate);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/concatenate.50a3c2dc.svg";